import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Button from 'shared/button';
import Errors from 'components/form/errors';
import Form from './form';
import Modal from 'components/modal';
import { put } from 'helpers/api';
import { hasAllDealTypes, serialize } from './helpers';
import { useCustomFieldForm } from './hooks';

export default function CustomFieldModal({
  customField, customFields, paths, show, features, options: initialOptions, onHide, onSave
}) {
  const [allowTypeChange, setAllowTypeChange] = useState(true);
  const [errors, setErrors] = useState();
  const [saving, setSaving] = useState();
  const { formField, options, setFormField, resetFormField } = useCustomFieldForm({
    dealTypes: [],
    classNames: ['Apex::Deal'],
  }, initialOptions, features);

  function reset() {
    const allDealTypes = options.dealTypes.map(option => option.value);

    let field;
    if (customField) {
      field = { ...customField };
      if (hasAllDealTypes(field, options)) {
        field.dealTypes = allDealTypes;
      }
    } else {
      field = {
        contactTypes: [],
        dealTypes: allDealTypes,
        classNames: features.edge ? [] : ['Apex::Deal'],
        sortOrder: customFields.length,
      };
    }

    resetFormField(field);
    setAllowTypeChange(field.type !== 'date');
    setErrors(null);
    setSaving(false);
  }

  async function save() {
    setErrors(null);
    setSaving(true);

    const serializedField = serialize(formField, customFields, options, { isNew: !customField });

    try {
      onSave(await put(paths.customFields, { customField: serializedField }));
      onHide();
    } catch (errors) {
      setErrors(errors);
      setSaving(false);
    }
  }

  return (
    <Modal show={show} onHide={onHide} onShow={reset}>
      <Modal.Header closeButton>
        {customField ? 'Edit' : 'New'} custom field
      </Modal.Header>

      <Modal.Body>
        <Errors description={null} errors={errors} />

        <Form
          allowAddingToPlaybook={!customField}
          allowTypeChange={allowTypeChange}
          customField={formField}
          features={features}
          options={options}
          onChange={setFormField}
        />
      </Modal.Body>

      <Modal.Footer>
        <Button.Cancel onClick={onHide} />
        <Button.Primary disabled={saving} label="Save" onClick={save} />
      </Modal.Footer>
    </Modal>
  );
}

CustomFieldModal.propTypes = {
  customField: PropTypes.object,
  customFields: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
  })).isRequired,
  features: PropTypes.shape({
    edge: PropTypes.bool,
    marketingIntegration: PropTypes.bool,
  }).isRequired,
  options: PropTypes.shape({
    dealTypes: PropTypes.array.isRequired,
  }).isRequired,
  paths: PropTypes.shape({
    customFields: PropTypes.string.isRequired,
  }).isRequired,
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
};
